import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "file-container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelected()))
  }, [
    _createElementVNode("img", {
      src: _ctx.data.symbol,
      alt: ""
    }, null, 8, _hoisted_1),
    _createElementVNode("div", null, _toDisplayString(_ctx.data.name), 1)
  ]))
}